import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/call-intel-trial-expired.webp';

const thumbHashString = '/feBBIIPUfh6F4woCHxasLl3dISIB4h4AA==';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 1.3248730964467006;
const originalWidth = 4176;

const CallIntelTrialExpired = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default CallIntelTrialExpired;
